import _ from "lodash";
import React, { useEffect, useState } from "react";

import ScheduleActionDialog from "./ScheduleActionDialog";
import ScheduleReviewDialog from "./ScheduleReviewDialog";
import "./styles.scss";

const ScheduleDialog = (props) => {
  const { cancelHandler, submitHandler } = props;

  const [currentStep, setCurrentStep] = useState("scheduleActionDialog");
  const [activeScheduleDetails, setActiveScheduleDetails] = useState(props.activeScheduleDetails);
  const [dialogType, setDialogType] = useState(props.type);

  const callTimeStamp = _.get(activeScheduleDetails, "timestamp", "");
  const providerName = _.get(activeScheduleDetails, "provider_name");
  const eventType = _.get(activeScheduleDetails, "event_type", "");
  const providerId = _.get(activeScheduleDetails, "provider_username", "");

  useEffect(() => {
    setActiveScheduleDetails(props.activeScheduleDetails);
    setDialogType(props.type);
  }, [props.activeScheduleDetails, props.type]);

  if (!activeScheduleDetails) {
    return <></>;
  }

  const typeConfigMap = {
    cancel: {
      actionSubmitHandler: () => setCurrentStep("reviewDialog"),
      buttonFormat: "Continue",
      feeFormat: "cancelling",
      titleFormat: "cancel",
    },
    reschedule: {
      actionSubmitHandler: () => submitHandler(activeScheduleDetails),
      buttonFormat: "Continue to Reschedule",
      feeFormat: "rescheduling",
      titleFormat: "reschedule",
    },
  };

  const sharedProps = {
    activeScheduleDetails,
    callId: activeScheduleDetails.callId,
    callTimeStamp,
    cancelHandler,
    currentStep,
    eventType,
    providerId,
    providerName,
    setCurrentStep,
    submitHandler,
    type: dialogType,
    typeConfigMap,
  };

  const stepMap = {
    reviewDialog: <ScheduleReviewDialog {...sharedProps} />,
    scheduleActionDialog: <ScheduleActionDialog {...sharedProps} />,
  };

  return (
    <div className="ScheduleDialog position-fixed d-flex align-items-center tw:justify-center">
      <div
        className="ScheduleDialog__inner p-5 d-flex flex-column text-center position-absolute"
        data-public
      >
        {_.get(stepMap, currentStep)}
      </div>
    </div>
  );
};

export default ScheduleDialog;
